import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ClientService } from "../../_services/client.service";
import { PlanningMessagesService } from "../../_services/planning-messages.service";

import { IMyDpOptions, IMyDateModel } from "mydatepicker";
import { DateService } from "../../_services/date.service";
import { Router, ActivatedRoute } from "@angular/router";

import { ToastService } from "../../_services/toast.service";

declare var jQuery: any;
import "../../../assets/semantic/semantic.min.js";

import * as moment from 'moment';

@Component({
  selector: "app-client",
  templateUrl: "./client.component.html",
  styleUrls: ["./client.component.css"],
})
export class ClientComponent implements OnInit {
  private selectedDate: Date;
  private plannings: any[] = [];
  private client;
  private plannings_count: number = 0;
  private full: number = 0;
  private grouped: number = 0;
  private monthly_margin: number = 0;
  private unread: Array<number> = [];
  private lates: number = 0;
  private todos: number = 0;
  private order: string = "departure_date asc";
  private hanging_planning;
  // Pagination variables
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];
  private page_param: string;
  private isLate: boolean = false;
  private isUnreadFilterEnabled: boolean = false;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };
  constructor(
    private service: ClientService,
    private planningMessagesService: PlanningMessagesService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) {}

  filters = new FormGroup({
    havetasks: new FormControl(),
    number: new FormControl(),
    state: new FormControl(),
    client_id: new FormControl(),
    transporter_id: new FormControl(),
    receiver_id: new FormControl(),
    departure_city: new FormControl(),
    departure_area: new FormControl(),
    departure_country: new FormControl(),
    arrival_city: new FormControl(),
    arrival_area: new FormControl(),
    arrival_country: new FormControl(),
    quantity: new FormControl(),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    buy_price: new FormControl(),
    sell_price: new FormControl(),
    note: new FormControl(),
    ref: new FormControl(),
    loading_hour: new FormControl(),
    shipping_hour: new FormControl(),
    ref_client_interne: new FormControl()
  });

    formatDate(date): string {
    moment.locale('fr');
    const formattedDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format('ddd DD-MM-YYYY');
    return formattedDate || '';
    }
  
  ngOnInit() {
    jQuery(".ui.checkbox").checkbox();
    this.selectedDate = new Date();
    this.getPlanning();
    this.filters.valueChanges.debounceTime(250).subscribe((value) => {
      // Check Departure & Arrival places Values:
      // If there is a departure_id city, clear the area & country inputs.

      if (value.departure_city) {
        this.filters.patchValue({
          departure_area: null,
          departure_country: null,
        });
      }
      // If there is a departure_id area, clear the country input
      if (value.departure_area) {
        this.filters.patchValue({ departure_country: null });
      }
      // If there is an arrival_id city, clear the area & country inputs
      if (value.arrival_city) {
        this.filters.patchValue({ arrival_area: null, arrival_country: null });
      }
      // If there is an arival area, clear the country input.
      if (value.arrival_area) {
        this.filters.patchValue({ arrival_country: null });
      }

      if (value.state == "") value.state = undefined;
      if (value.departure_date && value.departure_date.formatted)
        value.departure_date = value.departure_date.formatted;
      if (value.arrival_date && value.arrival_date.formatted)
        value.arrival_date = value.arrival_date.formatted;

      this.getPlanning(value);
    });
  }

  getPlanning(params?) {
    this.full = 0;
    this.grouped = 0;
    this.monthly_margin = 0;
    this.lates = 0;
    this.todos = 0;
    // If there is params, add the month_date to them, else, create it.
    params
      ? Object.assign(params, { month_date: this.selectedDate })
      : (params = { month_date: this.selectedDate });
    Object.assign(params, { page_number: this.page_number }); // Set Page param in request

    params.unread = this.unread;
    params.unread_only = this.isUnreadFilterEnabled;

    this.service.getPlanning(params).subscribe((response) => {
      this.isLate = false;
      this.plannings = response.plannings;
      // Pagination Management
      this.plannings_count = parseInt(response.total_count); // Planning Count
      this.page_number = parseInt(response.page); // Current Page
      this.page_count = Math.ceil(this.plannings_count / 10); // Page Count

      this.client = response.client;

      // Page Indicators (for ngFor iterations)
      if (this.page_count < 10) {
        this.page_indicators = Array(this.page_count).fill(1);
      } else {
        this.page_indicators = Array(10).fill(1);
      }
      this.plannings.forEach(
        function (planning) {
          // Filtering the plannings Tasks
          planning.late = new Date(planning.departure_date) < new Date();
          // To only keep the ones which are not done yet.
          planning.tasks = planning.tasks.filter(
            (task) => !task.checked && task.company_id == this.client.id
          );

          if (planning.provider_payment_date)
            planning.provider_payment_date = {
              jsdate: new Date(planning.provider_payment_date),
            };
        }.bind(this)
      );
      this.service.getMonthlyStats(this.selectedDate).subscribe((response) => {
        this.todos = response.todos;
        this.lates = response.lates;
        this.full = response.full_count;
        this.grouped = response.grouped_count;
        this.monthly_margin = response.monthly_margin;
        this.unread = response.unread;
      });
    });
  }

  updatePlanningFiles(params: any) {
    let planning = this.plannings.find(p => p.id == params.planning_file.planning_id);
    if (planning) {
      if (params.isDeleted)
        planning.planning_files = planning.planning_files.filter(pf => pf.id != params.planning_file.id);
      else
        planning.planning_files.push(params.planning_file);
    }
  }

  updatePlanningState(params: any) {
    let planning = this.plannings.find(p => p.id == params.planning_id);
    if (planning) planning.state = params.state;
  }

  updatePlanningChatData(planning_id: number) {
    this.planningMessagesService.getPlanningUserUnreadMessages(planning_id).subscribe(
      (response) => {
        //console.log("this.planningMessagesService.getPlanningUserUnreadMessages response:", response);
        let planning = this.plannings.find(p => p.id == planning_id);
        if (planning) planning.planning_unread_messages = response;
        if (!response.length) {
          this.unread = this.unread.filter(x => x != planning_id);
        } else if (this.unread.indexOf(planning_id) === -1) {
          this.unread.push(planning_id);
        }      },
      (error) => {
        console.log("this.planningMessagesService.getPlanningUserUnreadMessages error:", error);
        this.toast.error(
          error.error && error.error.message 
            ? error.error.message 
            : `Une erreur est survenue lors de la récupération des messages non lus du planning`,
          false,
          "Récupération des messages non lus du planning"
        );
      }
    );
  }

  showUnread() {
    this.isUnreadFilterEnabled = !this.isUnreadFilterEnabled;
    this.page_number = 0;
    this.getPlanning();
  }
  
  // Month Selector
  selectMonth(month) {
    this.selectedDate.setMonth(month);
    this.getPlanning();
  }
  subYear() {
    this.selectedDate.setFullYear(this.selectedDate.getFullYear() - 1);
    this.getPlanning();
  }
  addYear() {
    this.selectedDate.setFullYear(this.selectedDate.getFullYear() + 1);
    this.getPlanning();
  }
  // Expand Line
  manageExpand(event) {
    var icon_tag = event.target;
    if (icon_tag.classList.contains("down")) {
      // If Expanding
      icon_tag.classList.remove("down");
      icon_tag.classList.add("up");
      icon_tag.parentElement.parentElement.getElementsByClassName(
        "planning-tasks"
      )[0].style = "display: auto;";
    } else {
      // Folding
      icon_tag.classList.remove("up");
      icon_tag.classList.add("down");
      icon_tag.parentElement.parentElement.getElementsByClassName(
        "planning-tasks"
      )[0].style = "display: none;";
    }
  }

  updateNote(planning_id, event) {
    var value = event.target.parentElement.getElementsByTagName("TEXTAREA")[0]
      .value;
    var params = {};
    params["note_client"] = value;
    this.service.updatePlanning(planning_id, params).subscribe((response) => {
      // this.getPlanning();
    });
  }

  updateState(planning, event) {
    let params = {};
    params["state"] = event.target.value;

    this.service.updatePlanning(planning.id, params).subscribe((response) => {
      this.plannings.forEach(function (p) {
        if (p.id == planning.id) {
          p.state = event.target.value;
          return;
        }
      });
      // this.getPlanning();
    });
  }
  // Previous Page Button
  previousPage() {
    this.page_number = this.page_number - 1;
    this.getPlanning();
  }

  // Next Page Button
  nextPage() {
    this.page_number = this.page_number + 1;
    this.getPlanning();
  }

  // Go to page n°nb
  toPage(nb: number) {
    if (nb != this.page_number) {
      this.page_number = nb;
      this.getPlanning();
    }
  }
  toggleFilters() {
    jQuery(".ui.sidebar").toggleClass("visible uncover");
  }
  closeSidebar() {
    jQuery(".ui.sidebar").removeClass("visible uncover");
  }
  //affiche toutes les tasks dans la modal
  showAllTasks() {
    jQuery("#tasks-list-modal").modal({ inverted: true }).modal("show");
  }
  //quand on ajoute une task (compo task-list) permet de mettre à jour le planning
  updatePlaningTasks() {
    this.getPlanning();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/client/client.component.ts